var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvMa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    enableBackground: "new 0 0 72 72",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.055,14.242v2.039H23.719v9.477h-7.266v-9.477H6.07v-2.039H34.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.488,14.242h7.5L54.21,25.758h-6.819L35.707,14.242h7.711l7.5,8.742L58.488,14.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.475,28.969h10.171v28.789h-6.587V38.285c0-0.56,0.008-1.344,0.022-2.354   c0.016-1.009,0.023-1.787,0.023-2.334l-6.41,24.16h-6.87l-6.364-24.16c0,0.547,0.008,1.325,0.023,2.334   c0.015,1.009,0.022,1.794,0.022,2.354v19.473H4.919V28.969h10.286l6.157,22.637L27.475,28.969z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.509,28.969h7.998l11.968,28.789H63.81l-2.231-5.918H49.12l-2.293,5.918h-7.394L51.509,28.969z    M51.043,46.879h8.664l-4.273-11.328L51.043,46.879z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvMa);
export default __webpack_public_path__ + "static/media/TV-MA.fa980c553bba51f80edb4cd71b8b3ef0.svg";
export { ForwardRef as ReactComponent };